import React from 'react'

export default function SiteBottom() {
  return (
    <footer className="py-4 osahan-copyright">
      <div className="container retro-footer-content">
        <p className="m-0 text-white-50">
          StareKomputery.pl © {new Date().getFullYear()} · Kolekcja i archiwum pasjonata
        </p>
        <p className="m-0 text-white-50">
          Strona wykonana przez{' '}
          <a className="text-white" href="https://soul-vision.dev/">Soul Vision</a>
        </p>
      </div>
    </footer>
  )
}
